import { useEffect } from "react";
import { ReactLenis, useLenis } from "lenis/react";

const LenisExpose = () => {
    const lenis = useLenis();
    useEffect(() => {
        if (lenis) window.__lenis = lenis;
    }, [lenis]);
    return null;
};

export const SmoothScroll = ({ children }) => {
    return (
        <ReactLenis
            root
            options={{
                lerp: 0.08,
                duration: 1.2,
                smoothWheel: true,
                wheelMultiplier: 1,
            }}
        >
            <LenisExpose />
            {children}
        </ReactLenis>
    );
};
